<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="pb-8">
        <v-container class="mt-4">
          <v-text-field
            v-model="title"
            single-line
            label="Name"
            required
          ></v-text-field>
          <v-text-field
            v-model="url"
            single-line
            label="URL Redirect"
            required
          ></v-text-field>
          <v-row>
            <v-col cols="12" md="6"
              ><v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="publishdate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="publishdate"
                    label="Start Date"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="publishdate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(publishdate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu></v-col
            >
            <v-col cols="12" md="6">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="enddate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="enddate"
                    label="End Date"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    v-bind="attrs"
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="enddate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(enddate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <div>
              <div class="d-flex align-center">
                <span class="grey--text">Set as Default</span>
                <v-tooltip bottom max-width="360">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#D19F09"
                      class="mx-3 cursor-pointer"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span
                    >If set as Default, when an ad with an End Date expires,
                    this add will fill its place until another add with an
                    active date range is added.</span
                  >
                </v-tooltip>
                <v-switch v-model="Default"></v-switch>
              </div>
              <div>
                Display to:
                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="Page"
                      single-line
                      :items="[
                        'Announcements',
                        'Blog',
                        'Career-Practitioner',
                        'Courses-Beginner',
                        'Courses-List',
                        'Courses-Upcoming',
                        'Practitioners',
                        'Store',
                        'Study Groups & Events',
                        'Survey',
                      ]"
                      label="Page"
                      required
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="Position"
                      single-line
                      :items="['1', '2']"
                      label="Position"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </div>
            </div>
            <v-divider class="mx-3"></v-divider>
            <div>Image Sizing Guidelines:</div>
            <div class="mb-5 mt-4">
              <v-card class="pa-3" flat>
                <v-row align="center" align-content="center">
                  <v-col cols="12" md="8">
                    <div class="spantwo my-1">Announcements - Position 1</div>
                    <div class="spantwo my-1">Blog - Position 2</div>
                    <div class="spantwo my-1">Career-Practitioners</div>
                    <div class="spantwo my-1">Courses (ALL) - Position 1</div>
                    <div class="spantwo my-1">Practitioners</div>
                    <div class="spantwo my-1">
                      Study Groups/Events - Position 1
                    </div>
                    <div class="spantwo my-1">Survey - Position 1</div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card
                      style="border-radius: 6px"
                      color="#C1DBEB"
                      flat
                      width="220px"
                      height="270px"
                      class="d-flex justify-center align-center"
                    >
                      <span>570 x 944 px</span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <div class="mb-5 mt-4">
              <v-card class="pa-3" flat>
                <v-row align="center" align-content="center">
                  <v-col cols="12" md="7">
                    <div class="spantwo my-1">Announcements - Position 2</div>
                    <div class="spantwo my-1">Courses (ALL) - Position 2</div>
                    <div class="spantwo my-1">
                      Study Groups/Events - Position 2
                    </div>
                    <div class="spantwo my-1">Survey - Position 2</div>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-card
                      style="border-radius: 6px"
                      color="#C1DBEB"
                      flat
                      width="220px"
                      height="170px"
                      class="d-flex justify-center align-center"
                    >
                      <span>570 x 420 px</span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <div class="mb-5 mt-4">
              <v-card class="pa-3" flat>
                <v-row align="center" align-content="center">
                  <v-col cols="12" md="4">
                    <div class="spantwo my-1">Blog - Position 1</div>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-card
                      style="border-radius: 6px"
                      color="#C1DBEB"
                      flat
                      height="80px"
                      class="d-flex justify-center align-center"
                    >
                      <span>1920 x 360 px</span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <div class="mb-5 mt-4">
              <v-card class="pa-3" flat>
                <v-row align="center" align-content="center">
                  <v-col cols="12" md="4">
                    <div class="spantwo my-1">Store</div>
                  </v-col>
                  <v-col cols="12" md="8" class="d-flex justify-end">
                    <v-card
                      style="border-radius: 6px"
                      color="#C1DBEB"
                      flat
                      height="110px"
                      width="140px"
                      class="d-flex justify-center align-center"
                    >
                      <span>400 x 327 px</span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            
            <div>
            <div><b>File</b></div>
               <v-btn
                class="text_style my-4 px-11"
                color="primary"
                outlined
                @click="onButtonClick"
                >Upload File</v-btn
              >
              <input
                ref="uploader"
                class="d-none"
                type="file"
                @change="onFileChanged"
              />
            </div>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AddAdvertsComponent",
  data() {
    return {
      valid: "",
      search: "",
      seletedialog: false,
      title: "",
      url: "",
      publishdate: "",
      enddate: "",
      //   date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      //     .toISOString()
      //     .substr(0, 10),
      menu1: false,
      menu2: false,
      cardFilterItem: [
        {
          active: true,
          heading: "Store",
          size: "183X150px",
          imagesize: "183X150px",
        },
        {
          active: true,
          heading: "Practioner",
          size: "285X472px",
          imagesize: "285X472px",
        },
        {
          active: true,
          heading: "Blog",
          size: "960X180px",
          imagesize: "960X180px",
        },
        {
          active: true,
          heading: "Courses",
          size: "285X472px",
          imagesize: "285X472px",
        },
        {
          active: true,
          heading: "Announcements",
          size: "285X472px",
          imagesize: "285X472px",
        },
        {
          active: true,
          heading: "Take Survey",
          size: "285X472px",
          imagesize: "285X472px",
        },
        {
          active: true,
          heading: "Study Groupes And Events",
          size: "285X472px",
          imagesize: "285X472px",
        },
      ],

      StoreArray: [
        { location: "Store page", stext: "/store" },
        { location: "Product_detail_page", stext: "/store/product_detail" },
      ],
      PractitionerArray: [{ location: "Practitioner page", stext: "/store" }],
      LearnArray: [
        { location: "Courses", stext: "/Courses" },
        // { location: "Courses", stext: "/Courses" },
      ],
      BlogArray: [{ location: "Blog", stext: "/blog" }],
      announcementsArray: [
        { location: "Announcements", stext: "/announcements" },
      ],
      surveyArray: [
        {
          location: "Take Survey",
          stext: "/Take Survey",
        },
      ],
      studyArray: [
        {
          location: "Study Groupes And Events",
          stext: "/Study Groupes And Events",
        },
      ],

      selectedLocations: [],
    };
  },
   methods: {
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.chip1 = true;
      this.selectedFile = e.target.files[0];
      this.UploadedfileName = this.selectedFile.name;
      //
      // do something
    },
  },
};
</script>

<style scoped>
.spanOne {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 400;
}
.spanTwo {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
}
.spanThree {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
}
.spanthree_one {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  color: #b2b3bb;
}
.selete_display_span {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.7);
}
.display_parent {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 500;
  color: rgba(8, 8, 22, 0.38);
}
.vSelete_itemOne {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}
.vSelete_itemTwo {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;

  color: rgba(8, 8, 22, 0.38);
}
.loaction_span {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.7);
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
